  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">SDDR Abierto</li>
            <li class="breadcrumb-item">Aportaciones de DI/FS</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda Aportaciones de DI/FS</h2>

          <div style="display: flex; align-items: center;">
            <button *ngIf="canAccessNuevoDis()" type="button" class="btn btn-primary" data-toggle="modal"
              (click)="openModalContributions()"><span class="icon-add"></span>Nueva aportación DI/FS</button>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
      <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
  <!-- Formulario de búsqueda -->
  <form *ngIf="mostrarFiltros" class="container form-search py-3" [formGroup]="searchForm">

      <div class="row form">
       <div style="max-width: 370px;" *ngIf="esGestorEnvalora()">
          <label for="acondicionador">Acondicionador </label>
          <div class="custom-mat-field">
           <lib-ge-select-pagination [endPointFilter]="listaGestores" [multiple]=true [updateList]="updateList"
              [placeHolder]="'-- Acondicionadores --'" [formControlNameSelect]="getFormControl('acondicionador')"
              [descripcion]="getGestorDescription"[objQueryName]="getGestorObjectQuery" [customClass]="rightHolder('acondicionador')"
              [defaultParameters]="defaultAcondicionadoresParameters"
              >
            </lib-ge-select-pagination>
          </div>
        </div>

        <div style="max-width: 370px;" *ngIf="isGestor">
          <ng-container>
            <label for="acondicionador">Acondicionadores </label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <mat-select formControlName="acondicionador" id="acondicionador" placeholder="-- Acondicionadores --" multiple>
                  <mat-option *ngFor="let acondicionador of nimaGestorArray" [value]="acondicionador">
                     {{ acondicionador.nima }} - {{ acondicionador.razonSocial }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
        </div>

        <div style="flex: 1 1 200px; max-width: 300px;">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple>
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>


      <!-- Acondicionador  -->

        <div style="max-width: 250px;" *ngIf="esGestorEnvalora()">
          <label for="idAcondicionador">ID. Acondicionador </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idAcondicionador" id="idAcondicionador" placeholder="ID. Acondicionador" type="text"  (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>
        <div style="max-width: 350px;" *ngIf="esGestorEnvalora()">
          <label for="razon_social_acond">Razón Social Acondicionador </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="razon_social_acond" id="razon_social_acond" placeholder="Razón Social Acondicionador" type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 290px; max-width: 300px;" *ngIf="esGestorEnvalora()">
          <label for="codigo_documento_acond">Documento Acondicionador (NIE, NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento_acond" id="codigo_documento_acond"
                placeholder="Documento Acondicionador (NIE, NIF)" type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="esGestorEnvalora()">
          <label for="nima_acondicionador">NIMA del acondicionador </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nima_acondicionador" id="nima_acondicionador" placeholder="NIMA del acondicionador " type="text">
            </mat-form-field>
          </div>
        </div>


       <!-- Gestor  -->
                <div style="max-width: 370px;" *ngIf="isGestor">
          <label for="gestor">Gestor </label>
          <div class="custom-mat-field">
            <lib-ge-select-pagination [endPointFilter]="listaGestores" [multiple]=true [updateList]="updateList"
              [placeHolder]="'-- Gestores --'" [formControlNameSelect]="getFormControl('gestor')"
              [descripcion]="getGestorDescription" [objQueryName]="getGestorObjectQuery" [customClass]="rightHolder('gestor')"
              [defaultParameters]="defaultGestoresParameters">
            </lib-ge-select-pagination>
          </div>
        </div>
        <div style=" max-width: 370px;" *ngIf="esGestorEnvalora()">
          <label for="gestor">Gestor </label>
          <div class="custom-mat-field">
             <lib-ge-select-pagination [endPointFilter]="listaGestores" [multiple]=true [updateList]="updateList"
              [placeHolder]="'-- Gestores --'" [formControlNameSelect]="getFormControl('gestor')"
              [descripcion]="getGestorDescription" [objQueryName]="getGestorObjectQuery" [customClass]="rightHolder('gestor')"
              [defaultParameters]="defaultGestoresParameters">
            </lib-ge-select-pagination>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;"*ngIf="esGestorEnvalora()">
          <label for="idGestor">ID. Gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idGestor" id="idGestor" placeholder="ID. Gestor" type="text" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>
        <div style="max-width: 370px;" *ngIf="esGestorEnvalora()">
          <label for="razon_social_gest">Razón Social Gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="razon_social_gest" id="razon_social_gest" placeholder="Razón Social Gestor" type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 290px; max-width: 300px;" *ngIf="esGestorEnvalora()">
          <label for="codigo_documento_gest">Documento Gestor (NIE, NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento_gest" id="codigo_documento_gest"
                placeholder="Documento Gestor (NIE, NIF)" type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="esGestorEnvalora()">
          <label for="nima_gestor">NIMA del gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nima_gestor" id="nima_gestor" placeholder="NIMA del gestor"
                type="text">
            </mat-form-field>
          </div>
        </div>


      <!-- Fecha desde hasta  -->

        <div style="flex: 1 1 200px; max-width: 210px;">
          <label for="fecha_desde">Fecha de aceptación desde <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker1" formControlName="fecha_desde">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker1"></mat-datepicker-toggle>
              <mat-datepicker #datepicker1>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_desde', 'required')">Campo
                obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('fecha_desde', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>

        </div>

        <div style="flex: 1 1 200px; max-width: 210px;">
          <label for="fecha_hasta">Fecha de aceptación hasta <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker2" formControlName="fecha_hasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_hasta', 'required')">Campo
                obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('fecha_hasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 190px; max-width: 190px;">
          <label for="fecha_desde">Fecha aportación desde</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker3" formControlName="fecha_aport_desde">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker3"></mat-datepicker-toggle>
              <mat-datepicker #datepicker3>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_aport_desde', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 190px; max-width: 190px;">
          <label for="fecha_hasta">Fecha aportación hasta</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker4" formControlName="fecha_aport_hasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker4"></mat-datepicker-toggle>
              <mat-datepicker #datepicker4>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_aport_hasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 250px; max-width: 300px;" *ngIf="esGestorEnvalora()">
          <label for="doc_identificacion">Doc. Identificación/Full Seguiment </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="doc_identificacion" id="doc_identificacion"
                placeholder="Doc. Identificación/Full Seguiment " type="text">
              <mat-error *ngIf="controlHasError('doc_identificacion', 'minlength')">Mínimo 6 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 190px; max-width: 190px;" *ngIf="esGestorEnvalora()">
          <label for="plataformaOrigen">Plataforma origen </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="plataformaOrigen" id="plataformaOrigen" placeholder="-- Plataforma origen --">
                <mat-option *ngFor="let des of plataformaOrigenArray" [value]="des">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('plataformaOrigen')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'plataformaOrigen')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 190px; max-width: 190px;" *ngIf="esGestorEnvalora()">
          <label for="origen">Origen </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="origen" id="origen" placeholder="-- Origen --">
                <mat-option  value="SDDRCA">
                 SDDR Abierto
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('origen')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'origen')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <!-- <div class="col-sm flex-grow-1" *ngIf="esGestorEnvalora()"></div> -->
        <!-- <div class="col-sm flex-grow-1" *ngIf="esGestorEnvalora()"></div> -->
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="esGestorEnvalora()">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="esGestorEnvalora()">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
              <mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table">{{ recordsTotal }} registros encontrados</span></div>
        <div class="text-right">
          <div class="d-inline">

            <div class=" d-flex d-inline dropdown show">
              <button *ngIf="canAccessCrearAutoFactura()" type="button" class="btn btn-primary margin-bton-auto"
                data-toggle="modal" (click)="crearAutoFactura()"><span class="icon-add"></span>Crear
                Prefactura</button>
              <a (click)="exportarExcel()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span class="mr-3">Exportar</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                (actionButton)="action($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario</p>
        <p class="mensaje-linea"></p>
      </div>
    </ng-template>
  </div>
